module.exports = __webpack_public_path__ + "img/login-bg.a7b9e890.svg";